<template>
  <div class="uk-radio--wrapper">
    <label>
      <input
        class="uk-radio"
        :class="{'uk-radio--fill': fill, 'uk-radio--red': color == 'red'}"
        type="radio"
        v-bind="$attrs"
        :checked="$attrs.checked || model == $attrs.value"
        @click="click"
        @change="Change"
      />
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [Object, Array, String, Number, Boolean],
      default: 'on'
    },
    fill: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    click() {
      this.$emit('click')
    },
    Change() {
      this.$emit('change', this.Value)
    }
  },
  computed: {
    Value() {
      if (typeof this.$attrs.value !== 'undefined') return this.$attrs.value
      return 'on'
    }
    /*picked: {
      get() {
        return this.model
      },
      set(v) {
        this.$emit('change', v);
      }
    }*/
  },
  created() {
    /*if (this.$attrs.checked != 'undefined') {
      this.picked = this.$attrs.value;
    }*/
  },
  mounted() {
    /*if ((typeof this.$attrs.value != 'undefined') && (typeof this.$attrs.checked != 'undefined')) {
      this.$el.firstElementChild.firstElementChild.checked = true;
    }*/
  }
}
</script>

<style lang="scss" scoped>
.uk-radio {
  height: 20px;
  width: 20px;
  margin-top: -4px;
  margin-right: 10px;
  border: 1px solid rgba(34, 34, 34, 0.1);
  background-position: 3px 3px;

  &:checked {
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6' cy='6' r='6' fill='%23222222' fill-opacity='0.8'/%3E%3Ccircle cx='6' cy='6' r='5.5' stroke='%23222222' stroke-opacity='0.2'/%3E%3C/svg%3E%0A");
  }

  &--fill {
    background: #ffffff;
    border: 1px solid #dd1319;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);

    &:checked {
      background-color: #e31e24;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
      background-image: none;
    }
  }

  &:disabled {
    background-color: #ffffff;

    &:checked {
      background-color: #ffffff;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6' cy='6' r='6' fill='%23cccccc' fill-opacity='0.8'/%3E%3Ccircle cx='6' cy='6' r='5.5' stroke='%23cccccc' stroke-opacity='0.2'/%3E%3C/svg%3E%0A");
    }
  }

  &--wrapper {
    &:not(:last-child) {
      margin-right: 30px;
    }
  }
}
</style>
